import { Button } from "antd";
import styled from "styled-components";

export const StyledHeaderReloadBtn = styled(Button)`
    padding: 4px;
    color: ${({ theme }) => theme.primaryTypographyColor};
    background: transparent;
    border: none;

    &:disabled {
        color: ${({ theme }) => theme.dangerTypographyColor};
        background: transparent;
    }
`;
